import { BulkProvisioningJobs } from './BulkProvisioningJobs.tsx';
import { BulkProvisioningFiltersURLParser } from './Filters/SearchParams/BulkProvisioningFiltersURLParser.tsx';

import { PageWithGraphs } from 'common/components/Layouts/PageLayout/PageWithGraphs.tsx';
import { ActivityLogTabs } from '@/activityLog/layout/ActivityLogTabs.tsx';
import { TabPanelWithErrorHandling } from 'common/components/AppLayout/Components/TabPanelWithErrorHandling.tsx';
import { useTranslation } from 'react-i18next';
import { useTabNavigationSetter } from 'common/components/AppLayout/AppNavigation/hooks/useTabNavigationSetter.ts';
import { activityLogNavigationAtom } from 'atoms/pages/pages.ts';
import { useBulkProvisioningUrlFromFilters } from '@/activityLog/bulkProvisioning/Hooks/useBulkProvisioningUrlFromFilters.ts';

export const SimProvisioning = () => {
  const { t } = useTranslation();

  const url = useBulkProvisioningUrlFromFilters();
  useTabNavigationSetter({ tabsAtom: activityLogNavigationAtom, routeToSet: url });

  return (
    <PageWithGraphs>
      <ActivityLogTabs>
        <TabPanelWithErrorHandling name={t('activityLog.tabs.simProvisioning')}>
          <BulkProvisioningFiltersURLParser>
            <BulkProvisioningJobs />
          </BulkProvisioningFiltersURLParser>
        </TabPanelWithErrorHandling>
      </ActivityLogTabs>
    </PageWithGraphs>
  );
};
